import Api from "@/services/Api";
import store from "@/store/store";

// The cache remembers which organisation it was filled for. Without this,
// switching organisation kept showing the first organisation's ARPU.
let cached = null;
let cachedFor = null;

export default function getEstateArpu() {
  var org = store.state.currentOrg;
  var key = (org && org.orgId) + "|" + store.state.orgToken;
  if (cached && cachedFor === key) return cached;
  cachedFor = key;
  cached = Api()
    .get("/billingSummary")
    .then(function (r) {
      var summaries = r.data || [];
      if (!summaries.length) return { summaries: [], rows: [] };
      return Api()
        .get("/organisation/networkBreakdown/" + summaries[0].id)
        .then(function (b) {
          return { summaries: summaries, rows: b.data || [] };
        });
    })
    .catch(function () {
      if (cachedFor === key) {
        cached = null;
        cachedFor = null;
      }
      return { summaries: [], rows: [] };
    });
  return cached;
}
